import { render, staticRenderFns } from "./PhsLogsListComponent.vue?vue&type=template&id=e3b0d626"
import script from "./PhsLogsListComponent.vue?vue&type=script&lang=js"
export * from "./PhsLogsListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports